
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import './dialog.css';
import { DialogButton } from '../../types';
import { Blocker, BlockerFunction, useBlocker } from 'react-router';
import { useTranslation } from '../../hooks';



export interface NavConfirmDialogProps {
    id?: string;
    text: string;
    title: string;
    block: boolean;

}

/**
 * Displays a confirmation dialog when router navigation attempts occur while `block` is true.
 * @param props Dialog configuration including messaging and blocking flag.
 * @returns PrimeReact dialog prompting the user to confirm navigation.
 */
export function NavConfirmDialog(props: NavConfirmDialogProps) {
    
    const translate = useTranslation();

    let shouldBlock = useCallback<BlockerFunction>(
        ({ currentLocation, nextLocation }) =>
          props.block && currentLocation.pathname !== nextLocation.pathname,
        [props.block]
      );
      let blocker = useBlocker(shouldBlock);


    const buttons: DialogButton[] =
        [{ id: 'yes', text: "YES", icon: "pi pi-check"},
        { id: 'no', text: "NO", icon: "pi pi-times", className: "p-button-secondary" }]



    /**
     * Handles dialog button clicks by proceeding with or cancelling navigation.
     * @param id Identifier of the button that triggered the action.
     */
    const handleClose = (id: any) => {

        if (id === 'yes') {
            blocker.proceed?.();
        } else {
            blocker.reset?.()
        }
    }


    /**
     * Renders dialog footer buttons for confirming or cancelling navigation.
     * @returns Array of button elements.
     */
    const renderFooter = () => {
        return buttons.map((value, index) => {
            return (
                <Button disabled={value.disabled} key={`btn-dialog-${index}`} label={translate(value.text)}
                    icon={(value.icon)}
                    onClick={() => handleClose(value.id)} className={`p-button-outlined fbx-button-outlined confirm-dialog-button ${value.className}`} />

            )
        })
    }






    return (
        <Dialog header={props.title} visible={blocker?.state === 'blocked'} className="confirm-exit-dialog" footer={renderFooter()} onHide={() => handleClose(0)}>
            <div >
                <span>{props.text}</span>
            </div>
        </Dialog>
    )
}